import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSketchfabComponent } from './simple-icons-sketchfab.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSketchfabComponent ],
    exports:      [ SimpleIconsSketchfabComponent ],
    bootstrap:    []
})
export class SimpleIconsSketchfabModule {}
